import { GeographicLevel } from 'app/shared/model/enumerations/geographic-level.model';

export interface ICountryOfBirth {
  id?: string;
  geographicLevel?: keyof typeof GeographicLevel;
  date?: string;
  geography?: string;
  geographyCode?: string;
  totalAllUsualResidents?: number | null;
  ukTotal?: number | null;
  england?: number | null;
  northernIreland?: number | null;
  scotland?: number | null;
  wales?: number | null;
  republicOfIreland?: number | null;
  otherEuCountries?: number | null;
  africa?: number | null;
  middleEastAsia?: number | null;
  farEast?: number | null;
  theAmericas?: number | null;
  antarcticaOceania?: number | null;
  otherCountries?: number | null;
}

export const defaultValue: Readonly<ICountryOfBirth> = {};
